import React, { useState, useEffect } from "react";
import "./Topinfobar.css";

const marqueeText =
  "📍 DocMaster's Head Quarters @ Electronic City, A 75 Sector 63 Noida  •  🏢 Associate of Shri Subhash Parasram Electronic Park Private Limited  •  ";

const Topinfobar = () => {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  if (isMobile) {
    return (
      <div className="top-info-bar top-info-bar--ticker">
        <div className="topbar-marquee-wrapper">
          <div className="topbar-marquee-track">
            <span>{marqueeText}</span>
            <span>{marqueeText}</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="top-info-bar">
      <span className="topbar-info-text">
        📍 DocMaster's Head Quarters @ The Electronic City, A 75 Sector 63 Noida
      </span>
      <span className="topbar-divider">|</span>
      <span className="topbar-info-text">
        🏢 Associate of Shri Subhash Parasram Electronic Park Private Limited
      </span>
    </div>
  );
};

export default Topinfobar;
